import { render } from "./EpisodeSubtitle.vue?vue&type=template&id=28639139&scoped=true"
import script from "./EpisodeSubtitle.vue?vue&type=script&lang=js"
export * from "./EpisodeSubtitle.vue?vue&type=script&lang=js"

import "./EpisodeSubtitle.vue?vue&type=style&index=0&id=28639139&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-28639139"

export default script